import { SessionState, SessionStore } from './session.store';
import { Query } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { LoginErrorModel } from '../../models/login/LoginErrorModel';
import { map, withLatestFrom } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ChronoUserPersonalRights } from '../../models/client-models';
import { ChronoUserRightsEnum } from 'src/app/core/models/client-models';
import {
  PersonalAuthorization,
  UserRightsModel,
} from '../../models/client-models';

@Injectable({
  providedIn: 'root',
})
export class SessionQuery extends Query<SessionState> {
  successful$ = this.select((state) => state.successful);
  user$ = this.select((state) => state.user);
  showSplash$ = this.select((state) => state.showSplash2Sek);
  token$ = this.select((state) => state?.user?.token);
  redirectUrl$ = this.select((state) => state.redirectUrl);
  visumWithTime$ = this.select((state) => state.visumWithTime);
  hasErrors$ = this.selectError<LoginErrorModel>().pipe(
    withLatestFrom(this.selectLoading()),
    map(
      ([error, loading]) =>
        error?.personalNR != undefined ||
        error?.general != undefined ||
        (error?.password != undefined && !loading)
    )
  );
  isOrderReadOnly$ = this.user$.pipe(
    map((u) => u?.user?.userRights?.order === ChronoUserPersonalRights.ReadOnly)
  );
  fullName$ = this.select(
    (state) => state.user?.firstname + ' ' + state.user?.lastname
  );
  numberAndName$ = this.select((state) =>
    state?.user.id
      ? state.user?.number +
        ' - ' +
        state.user?.firstname +
        ' ' +
        state.user?.lastname
      : ''
  );
  admiaNumberandName$ = this.select((state) =>
    state?.user ? state.user?.user?.name : ''
  );

  language$ = this.select((state) => state.user?.language);

  idPerson$ = this.select((state) => state.user?.id);
  userId$ = this.select((state) => state.user?.user.id);
  isAdmin$ = this.select((state) => state.user?.user?.admin);

  authorization$ = this.select((state) => state.user?.authorization);

  comeAndGo$ = this.select((state) => state.user?.authorization?.comeAndGoEdit);

  showPersonalList$ = this.select((state) => state.showPersonalList);

  newTimeEntryPermission$ = this.select(
    (state) =>
      state.user?.authorization?.comeAndGoEdit ||
      state.user?.authorization?.absenceEdit ||
      state.user?.authorization?.absenceAsk
  );

  newAbsencePermission$ = this.select(
    (state) =>
      state.user?.authorization?.absenceEdit ||
      state.user?.authorization?.absenceAsk
  );

  chronoVersion$ = this.select((state) => state.chronoVersion);

  nativeDevice$ = this.select((state) => state.nativeDevice);

  menuToggle$ = this.select((state) => state.menuToggle);

  chronoUserRights$ = this.select((state) => state.user?.user?.userRights);

  email$ = this.select((state) => state?.user?.user?.email);

  constructor(protected store: SessionStore) {
    super(store);
  }

  getChronoVersion() {
    return this.getValue()?.chronoVersion;
  }

  getAuth(): PersonalAuthorization {
    return this.getValue()?.user?.authorization;
  }

  getAdmiaUserAuth(): UserRightsModel {
    return this.getValue()?.user?.user?.userRights;
  }

  getPersonID() {
    return this.getValue()?.user?.id;
  }

  // getPersonEmail() {
  //   return this.getValue()?.user?.
  // }

  getPerson() {
    return this.getValue()?.user;
  }

  getAdmiaUserID() {
    return this.getValue()?.user?.user?.id;
  }

  selectAdmiaUserID() {
    return this.select((state) => state?.user?.user?.id);
  }

  getLanguage(): string {
    return this.getValue()?.user?.language;
  }

  getVisumWithTime(): boolean {
    return this.getValue()?.visumWithTime ?? false;
  }

  getPersonalDataRightsOfUser() {
    return this.getValue()?.user?.user?.userRights?.tabRights?.personalData;
  }

  selectPersonalDataRightsOfUser() {
    return this.select(
      (state) => state?.user?.user?.userRights?.tabRights?.personalData
    );
  }

  getIsAdmin() {
    return this.getValue()?.user?.user?.admin;
  }

  getPersonalUserRights() {
    return this.getValue()?.user?.user?.userRights.personal;
  }

  gettPersonalRightsUserRights() {
    return this.getValue()?.user?.user?.userRights.personalRights;
  }

  selectPersonalUserRights(): Observable<ChronoUserPersonalRights> {
    return this.select((state) => state?.user?.user?.userRights.personal);
  }

  selectPersonalRightsUserRights(): Observable<ChronoUserRightsEnum> {
    return this.select((state) => state.user?.user?.userRights.personalRights);
  }
}
